
import React, { useState } from "react";
import { Row } from "react-bootstrap";
import { makeStyles } from '@material-ui/core/styles';
import HeroImage from '../../ProductLanding/HeroImage';
import { Button } from '@material-ui/core';
import { Link } from 'react-scroll';

const useStyles = makeStyles(theme => ({
    hyperlinks: {
      backgroundColor: 'white',
      margin: '0px -40px',
      color: theme.palette.primary.main,
      boxShadow: '5px 3px 5px lightgrey'
    },
    activeLink: {
      borderBottom: `2px solid ${theme.palette.primary.main}`
    },
    productTab:{
      position: 'sticky',
      top:74,
      zIndex:9
    }
}));

const useButtonStyles = makeStyles((theme) => ({
    button: {
      color: theme.palette.primary.main,
      fontWeight: 700
    },
}));


const ProductHeader = ({
    data,
    permission
}) => {

    const classes = useStyles();
    const buttonStyle = useButtonStyles().button;

    return (
        <div id="product-header" className={classes.productTab}>
            <HeroImage title={data.name} subtitle={data.subtitle} permission={permission} />
            <Row className={classes.hyperlinks}>
                {data.hyperlinks.map((h, i) =>
                  <Link key={i} className={`sub-nav-link-button`} to={h.link} spy={true} smooth={true} offset={-395} duration={500}>
                    <Button variant="text" className={buttonStyle}>{h.title}</Button>
                  </Link>
                )}
            </Row>
        </div>
    )
}


export default React.memo(ProductHeader);



// WEBPACK FOOTER //
// ./src/components/Common/ProductHeader/ProductHeader.js